import React,{useState,useEffect,useRef} from "react";
import TrophyImage from "../../../assets/images/TrophyImage.png";
import goldenPeacockAward from "../../../assets/images/goldenPeacockAward.png";
import preschoolAward from "../../../assets/images/preschoolAward.png";
import franchisorAward from "../../../assets/images/2023-franchisor.jpg";
import EducationAndSkill from "../../../assets/images/2023-Education-and-skill.jpg";
import franchisor_Frow_Award from "../../../assets/images/franchisor-Frow-Award.jpg";
import multimediaAward from "../../../assets/images/2023-multimedia.jpg";
// import Slider from "react-slick"; // Already imported
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import AwardsCard from "../../CustomComponent/AwardsCard.tsx";
import styles from "./Award.module.scss";
import ImageTextSection from "../../CustomComponent/ImageTextSection.tsx";
import { Icon } from "../../../assets/Icons.tsx";
// import newAward from '../../../assets/images/newAward.png'

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2.5,
    slidesToSlide: 1,
    partialVisibilityGutter: 200,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 2,
    slidesToSlide: 1,
    partialVisibilityGutter: 40,
  },
  mobile: {
    breakpoint: { max: 767, min: 0 },
    items: 1,
    slidesToSlide: 1,
    partialVisibilityGutter: 40,
  },
};
interface Award {
  image: string;
  description: string;
}

const awards: Award[] = [
  {
    image: goldenPeacockAward,
    description:
      "Golden Peacock National Training Award 2024 at the 2024 UAE Global Convention & 31st Annual World Congress on Leadership for Innovation & Business Excellence.",
  },
  {
    image: preschoolAward,
    description:
      "Aptech International Pre-School has won a jury’s choice award as ‘Pre-school with Best Curriculum’ at the 5th edition of Scoonews Global Educators Fest 2023.",
  },
  {
    image: franchisorAward,
    description: `Aptech has won ‘Franchisor of the Year-Vocational Skilling and Training’ award in The Franchise Awards 2023.`,
  },
  {
    image: EducationAndSkill,
    description:
      "Aptech recognized as Leading I.T. Education and Skill Development Brand at the 25th World Education Summit ",
  },
  {
    image: franchisor_Frow_Award,
    description:"Aptech recognized as the Best Franchisor of the year for Education at FRO (Franchise & Retail Awards 2021, 2022 and 2023"
  },
  {
    image: multimediaAward,
    description:`Arena Multimedia recognized as "Leading Multimedia and Animation Training Brand" at the 25th World Education Summit`
  }
];
const content = [
  `<strong>Aptech's</strong> rapid growth over the years has resulted in numerous milestones in India and abroad. The company has received several prestigious awards for its outstanding contributions to the <strong>vocational training</strong> and <strong>skill development</strong> sectors, strengthening its leadership in the industry.`,
];

const Awards: React.FC = () => {
  
  return (
    <div id="studentAward" className={styles.studentAward}>
      <div className="container">
        <div className="">
          <Banner />
          </div>
          </div>

          <div className="container-fluid">
<div className="section">
          <AwardCardsSection />
          </div>
          <div className="section">

          <MarqueSection />
          </div>
          </div>
        </div>
      // </div>
    // </div>
  );
};
const Banner = () => {
  return (
    <div className="subSection">
    <div className="row">
      <div className="col-12">
        <ImageTextSection
          imageSrc={TrophyImage}
          imageAlt="TrophyImage"
          content={content}
          colImageValue={3}
          colTextValue={9}
          reverse={false}
          heading="AWARDS AND ACHIEVEMENTS"
          showMoreButton={true}
          buttonText="More Awards"
          navigateTo="/about-us/award-achievement"
          imageHeightMobile={`15rem`}
          imageHeightTablet={`15rem`}
          imageHeight={"auto"}
          contentPosition={true}
        />
      </div>
    </div>
    </div>
  );
};
const AwardCardsSection = () => {
  // const PrevArrow = ({ onClick }: { onClick?: () => void }) => (
  //   <div className={styles.prevArrow} onClick={onClick}>
  //     <Icon name="backArrowAward" color="pink" />
  //   </div>
  // );

  // const NextArrow = ({ onClick }: { onClick?: () => void }) => (
  //   <div className={styles.nextArrow} onClick={onClick}>
  //     <Icon name="forWardArriwAward" />
  //   </div>
  // );
  
  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3.3, // Show 3 full + 1 partial
    slidesToScroll: 1,
    // nextArrow: <NextArrow />,
    // prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.2,
        },
      },
    ],
  };
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const sliderRef = useRef<Carousel>(null); // Slider reference
  const isSmallScreen = screenWidth < 1025; // Small screens

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const handleNext = () => {
    if (sliderRef.current) {
      sliderRef.current.next(); // Use `next()` instead of `slickNext`
    }
  };

  const handlePrev = () => {
    if (sliderRef.current) {
      sliderRef.current.previous(); // Use `previous()` instead of `slickPrev`
    }
  };
  return (
    <div className="section">
                  <div
              className={`${styles.buttonGroup} control-btn  d-flex justify-content-end mb-4`}
            >
              <span className={styles.arrowButtonPrev} onClick={handlePrev}>
                <Icon
                  name="backArrowAward"
                  width={`${isSmallScreen ? "40px" : "50px"}`}
                  height={`${isSmallScreen ? "40px" : "50px"}`}
                />
              </span>

              <span className={styles.arrowButtonNext} onClick={handleNext}>
                <Icon
                  name="forWardArriwAward"
                  width={`${isSmallScreen ? "40px" : "50px"}`}
                  height={`${isSmallScreen ? "40px" : "50px"}`}
                />
              </span>
              </div>
              <Carousel
            additionalTransfrom={0}
            arrows={false}
            autoPlaySpeed={3000}
            centerMode={false}
            // infinite
            partialVisible
            responsive={responsive}
            slidesToSlide={1}
            swipeable
            ref={sliderRef}
            className={styles.AwardSection}
            
          >
    {awards.map((award, index) => (
      <div key={index} className="px-2">

        <div style={{ height: "auto" }}>
          <div
            className={`d-flex flex-column justify-content-between ${styles.awardMainDiv}`}
            style={{ height: "auto" }} // or whatever height you prefer
          >
            <AwardsCard
              awardImage={award.image}
              description={award.description}
            />
          </div>
        </div>
      </div>
    ))}
  </Carousel>
  </div>
  

  );
};

const MarqueSection =()=>{
  return(
    <><div className={`${styles.marqueSection} row`}>
      <div className="col-12">
        <p className="heading text-center">500+ Trusted hiring partners</p>
        <p className="para text-center">Aptech has partnered with leading companies to ensure that students have access to diverse career paths. Some of our prominent placement partners include:</p>

      </div>

    </div>
    <div className={styles.scrollContainer}>
        <div className={styles.scrollDiv}>
          {[
            "Accenture", "Amazon", "Celebi", "Indigo", "Indira Gandhi International Airport",
            "Lakshya", "DNEG", "Red Chillies Entertainment", "Minimalist",
            "Lakmé Salon", "Enrich", "VLCC", "Aditya Birla Fashion and Retail",
            "Nykaa", "M.A.C"
          ].concat([
            "Accenture", "Amazon", "Celebi", "Indigo", "Indira Gandhi International Airport",
            "Lakshya", "DNEG", "Red Chillies Entertainment", "Minimalist",
            "Lakmé Salon", "Enrich", "VLCC", "Aditya Birla Fashion and Retail",
            "Nykaa", "M.A.C"
          ]).map((item, index) => (
            <div key={index} className={`${styles.scrollItem} cardHeading`}>
              {item}
            </div>
          ))}
        </div>
      </div></>



  )
}
export default Awards;
